<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="stateOptions"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

const DEFAULT_STATE = 'default';

export default {
    name: 'text-decoration',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Text Decoration',
            state: DEFAULT_STATE,
            stateOptions: [
                { text: 'Default', value: 'default' },
                { text: 'On Hover', value: 'hover' },
            ],
            tailwindDefinitionProp: 'textDecoration',
            value: '',
        };
    },

    computed: {
        options() {
            const baseOptions = this.themeObjectValues.map(v => ({ text: this.titleCase(v), value: v }));

            baseOptions.unshift({ text: 'None', value: '' });

            return baseOptions;
        },

        states() {
            return this.stateOptions.map(opt => opt.value);
        },
    },

    watch: {
        state() {
            this.setSelectedValue();
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        setSelectedValue() {
            let { value } = this.flexClassDefinition;

            if (!value) {
                const computedValue = this.getComputedValue();
                const isSupported = this.themeObjectValues.includes(computedValue);

                if (isSupported) {
                    value = computedValue;
                }
            }

            this.value = value;
        },

        setSelectedState() {
            this.state = this.flexClassDefinition.state || DEFAULT_STATE;
        },

        onInput(valueNew) {
            let flexClassNew;

            if (valueNew) {
                flexClassNew = this.addFlexClass({
                    value: valueNew,
                    state: this.state,
                });
            } else {
                this.removeFlexClass(this.state);
            }

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onStateInput(newState) {
            this.state = newState;
        },

        onSelectedElement() {
            this.setSelectedState();
            this.setSelectedValue();
        },
    },
};
</script>
